module.exports = __webpack_public_path__ + "img/startnow.d28b0ab.webp";